import React, { ReactNode, useState } from "react";
import styled from "styled-components";
import { Gender } from "@linkfluence/models/gender";
import { Locale } from "@linkfluence/models/locale";
import Chart from "./chart";
import { useGetSeries } from "./data";
import Legend from "./legend";

const Root = styled.div`
  height: 100%;
`;

interface RangeData {
  range: string;
  data: {
    [Gender.Male]: number;
    [Gender.Female]: number;
  };
}

interface IProps {
  data: RangeData[];
  locale: Locale;
  tooltip?: (serie: any) => ReactNode;
  interactionSelectRange?: (range: string) => void;
  interactionSelectRangeValue?: (range: string, gender: string) => void;
  disableAnimation?: boolean;
}

const Demography = ({
  data,
  locale,
  tooltip,
  interactionSelectRange,
  interactionSelectRangeValue,
  disableAnimation = false,
}: IProps) => {
  const [hovered, setHovered] = useState(null);
  const series = useGetSeries(locale);
  return (
    <Root>
      <Legend
        data={data}
        series={series}
        locale={locale}
        setHovered={setHovered}
        disableAnimation={disableAnimation}
      />
      <Chart
        hovered={hovered}
        data={data}
        locale={locale}
        interactionSelectRange={interactionSelectRange}
        interactionSelectRangeValue={interactionSelectRangeValue}
        tooltip={tooltip}
        series={series}
      />
    </Root>
  );
};

export default Demography;
